export const listOrganizationAccounts = `
   query listOrganizationAccounts($filter:OrganizationAccountsFilterInput) {
       listOrganizationAccounts(filter:$filter) {
           items {
              id
              organizationId
              accountId
              account {
                  id 
                  email
              }
              organizationAccountStatus
           }
       }
   }
`;

export const listOrganizationAccountsWithPagination = `
       listOrganizationAccounts {
           items {
              id
              organizationId
              accountId
              account {
                  id 
                  email
              }
              organizationAccountStatus
           }
       }
   }
`;

export const getOrganizationAccount = `
   query getOrganizationAccount($id:ID!) {
       getOrganizationAccount(id:$id) {
         id
         organizationId
         accountId
         account {
             id 
             email
         }
         organizationAccountStatus
         created
         updated
       } 
}`;
